import React, { createRef, useState } from "react";
import classNames from "classnames";
import { useClasses, Col, Row } from "../../";
import Color from "color";
const style = (theme) => ({
    wrapper: {
        width: "100%",
        minHeight: (props) => props.height || "100%",
        marginTop: (props) => (props.inline ? "0px" : "18px"),
    },
    holder: {
        background: theme.palette.get("formBackground"),
        boxSizing: "border-box",
        width: "100%",
        borderRadius: "2px",
        color: "#797979",
        height: (props) => props.height || "100%",
        cursor: "pointer",
        border: `3px dashed ${Color(theme.palette.get("formBackgroundActive"))
            .darken(0.2)
            .hex()}`,
        outline: "none",
    },
    holderError: {
        borderColor: theme.palette.get("danger"),
        color: theme.palette.get("danger"),
    },
    holderBlank: {
        boxSizing: "border-box",
        width: "100%",
        height: (props) => props.height || "100%",
        cursor: "not-allowed",
        outline: "none",
    },
    preview: {
        maxWidth: "100%",
        maxHeight: (props) => props.height || "100%",
    },
    helpBlock: {
        fontSize: "0.8rem",
        lineHeight: "0.8rem",
        color: "rgba(0, 0, 0, 0.75)",
    },
    hasError: {
        color: "rgba(156, 0, 0, 1)",
    },
});
const toBase64 = (file, setPending) => new Promise((resolve, reject) => {
    setPending(true);
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
        if (typeof reader.result === "string") {
            const base64 = reader.result.substr(reader.result.indexOf(","));
            resolve(file.name + base64);
        }
        else
            resolve(undefined);
        setPending(false);
    };
    reader.onerror = (error) => {
        reject(error);
        setPending(false);
    };
});
const UploadArea = (props) => {
    var _a, _b;
    const { children, pendingElement = React.createElement("div", null, "Pending..."), onChange, onFileChange, onError = () => { }, } = props;
    const [pending, setPending] = useState(false);
    const inputRef = createRef();
    const classes = useClasses(style, props);
    const hasError = Boolean(props.error);
    const hasInfo = Boolean(props.info);
    return (React.createElement("div", { className: classNames([classes.wrapper, (_a = props.override) === null || _a === void 0 ? void 0 : _a.wrapper]) },
        React.createElement("section", { onDragOver: (event) => event.preventDefault(), onDrop: async (event) => {
                event.preventDefault();
                if (pending)
                    return;
                if (inputRef.current) {
                    inputRef.current.files = event.dataTransfer.files;
                    const file = inputRef.current.files[0];
                    if (onFileChange)
                        onFileChange(file);
                    if (onChange) {
                        try {
                            const result = await toBase64(file, setPending);
                            onChange(result);
                        }
                        catch (error) {
                            onError(error);
                        }
                    }
                }
            }, onClick: () => {
                if (inputRef.current)
                    inputRef.current.click();
            }, className: classNames([
                classes.holder,
                (_b = props.override) === null || _b === void 0 ? void 0 : _b.holder,
                hasError && classes.holderError,
            ]) },
            React.createElement("input", { ref: inputRef, style: { display: "none" }, type: "file", onChange: async (e) => {
                    e.preventDefault();
                    if (pending)
                        return;
                    if (e.target.files) {
                        const file = e.target.files[0];
                        if (onFileChange)
                            onFileChange(file);
                        if (onChange) {
                            try {
                                const result = await toBase64(file, setPending);
                                onChange(result);
                            }
                            catch (error) {
                                onError(error);
                            }
                        }
                    }
                } }),
            React.createElement(Row, { stretch: true, horizontalAlign: "center", verticalAlign: "center" },
                React.createElement(Col, { xs: "auto" },
                    pending && pendingElement,
                    !pending && children))),
        hasInfo && !hasError && (React.createElement("span", { className: classNames([classes.helpBlock]) }, props.info)),
        hasError && (React.createElement("span", { className: classNames([classes.helpBlock, classes.hasError]) }, props.error))));
};
export default UploadArea;
